import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=48ec5a14&scoped=true&"
import script from "./Profil.vue?vue&type=script&lang=js&"
export * from "./Profil.vue?vue&type=script&lang=js&"
import style0 from "./Profil.vue?vue&type=style&index=0&id=48ec5a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec5a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ec5a14')) {
      api.createRecord('48ec5a14', component.options)
    } else {
      api.reload('48ec5a14', component.options)
    }
    module.hot.accept("./Profil.vue?vue&type=template&id=48ec5a14&scoped=true&", function () {
      api.rerender('48ec5a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Profil.vue"
export default component.exports